export default {
	"languages": [],
	languagesSpoken: [{
		title: "",
	}],
	"public": "",
	"gap": "",
	"wc": "",
	"mvit": "",
	"dva": "",
	"children": "",
	childrenPreference: "",
	"hospitals": [],
	hospitalsMore: [
		{ title: ""}
	],
	interestsValues: [],
	"interests": [
		
	],
	fieldValue: [],
	fieldsValues: [],
	"fields": [],
	"field": {
	  "title": ""
	},
	"clinics": [],
	"clinic": {
	  "website": "",
	  "email": "",
	  "fax": "",
	  "phone": "",
	  "address": "",
	  "country": "",
	  "state": "",
	  "postcode": "",
	  "city": "",
	  "suburb": "",
	  "street2": "",
	  "street": "",
	  "number": "",
	  "suite": "",
	  "image": "",
	  "logo": "",
	  "othername": "",
	  "name": ""
	},
	"preferred": "",
	"website": "",
	"email": "",
	"emailPreference": "Yes",
	"mobile": "",
	"mobilePreference": "Yes",
	"fax": "",
	"phone": "",
	"qualification": "",
	"college": "",
	"image": "",
	"about": "",
	"gender": "",
	"othername": "",
	
	consultationFee: "",
	patientsPreferences: [
		{title: ""}
	],
	billingPolicy: {
		"All patients privately billed": false,
		"Reduced gap for healthcare card": false,
		"Reduced gap for pensioners": false,
		"Reduced gap for children": false,
		"Bulk bill healthcare card": false,
		"Bulk bill pensioners": false,
		"Bulk bill children": false,
		"All patients bulk billed": false,
		"Prefer not to say": false,
	},
	"name": "",
	"lname": "",
	"fname": "",
	"title": "",
}


// WEBPACK FOOTER //
// ./src/Containers/store/initDoctor.js